import {
  aRulePage,
  mockRulesListForSelectQueryOperationQuery,
} from '__generated__';
import { SAMPLE_RULES } from 'mocks/shared/rules';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockRulesListForSelectQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          rules: aRulePage({
            objects: SAMPLE_RULES,
          }),
        },
      });
    }
  ),
];
